var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({ color: _vm.color })},[_vm._v("\n        "+_vm._s(_vm.data.status === 'Paid' ? '-' : _vm.timeSince(new Date(_vm.data.invoiceDueDate)))+"\n   ")])])}
var staticRenderFns = []

export { render, staticRenderFns }